import { useHistoricalStatusData } from "./useHistoricalStatusData";
import { useStatusDataByDeviceAndDate } from "./useStatusDataByDeviceAndDate";
import { QueryDeviceData } from "@/models/QueryDiagnosticDeviceData";

function findLatestZeroValues(devicesData: QueryDeviceData) {
  const result = [];

  for (const deviceId in devicesData) {
    const readings = devicesData[deviceId];
    for (let i = readings.length - 1; i >= 0; i--) {
      const { data, dateTime } = readings[i];

      if (data === 0) {
        result.push({ deviceId, dateTime });
        break;
      }
    }
  }

  return result;
}

export default function usePossibleChargingInterruptsByDeviceIds(deviceIds: string[]) {
  const fromDate = new Date(Date.now() - 2 * 24 * 60 * 60 * 1000);

  const { data: historicalChargingStates = {} } = useHistoricalStatusData(
    ["DiagnosticElectricVehicleChargingStateId"],
    deviceIds,
    fromDate,
    undefined,
    60000,
  );

  const latestChargeStateToZero = findLatestZeroValues(
    historicalChargingStates?.["DiagnosticElectricVehicleChargingStateId"],
  );

  const { data: socData } = useStatusDataByDeviceAndDate(
    latestChargeStateToZero,
    "DiagnosticStateOfChargeId",
  );

  return socData;
}
